export default "__VITE_ASSET__5XT4Skg5__"